export default function Content() {
  return (
    <div className="content">
      <div className="container is_smaller">
        <h1>Draft your tasks for today</h1>
      </div>
    </div>
  );
}
